import { all, fork, takeLatest, takeEvery } from 'redux-saga/effects';
import { fetchDetail, fetchTable, sendData } from '../helpers/sagaHelpers';

function* watchFetchRequestTypesTable() {
  yield takeLatest('requestTypes/fetchTable', fetchTable);
}

function* watchFetchRequestTypeDetail() {
  yield takeLatest('requestTypes/fetchDetail', fetchDetail);
}

function* watchSubmitRequestTypeDetail() {
  yield takeEvery('requestTypes/submitDetail', sendData);
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchRequestTypesTable),
    fork(watchFetchRequestTypeDetail),
    fork(watchSubmitRequestTypeDetail)
  ]);
}
